import React, { useRef, useEffect, useState } from 'react';
import {useInterval, showToast, getMapStyle, strArraySortAsc, getHighSeveriry} from '../common/app_common.js';
import {Title, TopSitesAlertStatusSection, LoadingSpinner} from '../common/component_common.js';
import mapboxgl, {Marker} from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import '../common/css/dashboard.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import {getApiSitesAlertStatus, getApiSitesSite, getApiSitesCount, getApiSites, getApiSitesSummary} from '../common/fetch_api/site.js';
import {getApiMapboxTokenCheck} from '../common/fetch_api/api_common.js';
import {getApiEdgeId} from '../common/fetch_api/edge.js';
import {SiteOffCanvas, EdgeOffCanvas} from './dash_board/offcanvas';
import {SelectEdgeModal, AeaModal} from './dash_board/modals.js';
import {getApiConfigSystem} from '../common/fetch_api/configuration'

const PageDashBoard = () => {
    const [update, setUpdate] = useState(false);
    const isStyleLoaded = useRef(false);
    const atferInit = useRef(false);

    const mapContainer = useRef(null);
    const maruMap = useRef(null);
    const mapTokenStatus = useRef(0);   //0: default, 1: ok, 2: error
    const showEdgeRef = useRef({flag:false, level:5.0, markerSize:1});
    const mapDefaultRef = useRef({lat:0, lng:0, zoom: 4, locationOffset: 0});
    const mapInfoRef = useRef({lat:0, lng:0, zoom: 4, level: 5});
    const [mapConfig, setMapConfig] = useState({lat:0, lng:0, zoom: 4});
    const selectSeverity = useRef('');

    const [loading, setLoading] = useState(false);
    
    const siteList = useRef([]);
    const resourceList = useRef([]);

    const [systemInfo, setSystemInfo] = useState(null);
    const [filterSeverityCur, setFilterSeverityCur] = useState('none');
    const [filterSeverityPre, setFilterSeverityPre] = useState('none');
    
    const [searchNameCur, setSearchNameCur] = useState('');
    const [searchNamePre, setSearchNamePre] = useState('');
    const [searchTypeCur, setSearchTypeCur] = useState('none');
    const [searchTypePre, setSearchTypePre] = useState('none');
    const [sitesAlertStatus, setSitesAlertStatus] = useState();
    const [sitesSummary, setSitesSummary] = useState();

    const [detailSiteInfo, setDetailSiteInfo] = useState('');
    const [detailSiteCanvas, setDetailSiteCanvas] = useState(false);
    const showDetailSiteCanvas = (siteInfo) => {
        setDetailSiteInfo(siteInfo);
        setDetailSiteCanvas(true);
    };
    const cloaseDetailSiteCanvas = () => setDetailSiteCanvas(false);
    
    const [detailEdgeInfo, setDetailEdgeInfo] = useState('');
    const [detailEdgeList, setDetailEdgeList] = useState([]);

    const [selectEdgeModal, setSelectEdgeModal] = useState(false);
    const showSelectEdgeModal = (e, siteInfo) => {
        const edgeType = e.target.getAttribute('edgeType');
        let edgeLocTxt = e.target.getAttribute('edgeLocTxt');

        if( edgeLocTxt === 'site' )
        {
            edgeLocTxt = `${siteInfo.longitude}_${siteInfo.latitude}`;
        }

        const edgeIdArr = siteInfo.edgeList.filter( (a) => { return `${a.longitude}_${a.latitude}` === edgeLocTxt && a.type === edgeType } );

        setDetailSiteInfo(siteInfo);

        if(edgeIdArr.length > 1)
        {
            setDetailEdgeList(edgeIdArr);
            setSelectEdgeModal(true);
        }
        else if(edgeIdArr.length === 1)
        {
            Promise.resolve( getApiEdgeId(edgeIdArr[0].id) )
            .then( edgeInfo => {
                setDetailEdgeInfo(edgeInfo);
                setDetailEdgeCanvas(true);
            });
        }
    };
    const cloaseSelectEdgeModal = () => setSelectEdgeModal(false);

    const [detailEdgeCanvas, setDetailEdgeCanvas] = useState(false);
    const showDetailEdgeCanvas = (edgeInfo) => {
        setDetailEdgeInfo(edgeInfo);
        setDetailEdgeCanvas(true);
    };
    const cloaseDetailEdgeCanvas = () => setDetailEdgeCanvas(false);
    
    const [aeaModal, setAeaModal] = useState(false);
    const showAeaModal = (siteInfo) => {
        setDetailSiteInfo(siteInfo);
        setAeaModal(true);
    };
    const cloaseAeaModal = () => setAeaModal(false);

    const siteWidgerConfig = useRef({
        collapse: true,
        height: 400,
    });

    const edgeWidgerConfig = useRef({
        collapse: true,
        height: 400,
        'm-agent': [...Array(11).keys()],
        's-agent': [...Array(7).keys()],
        'r-agent': [...Array(2).keys()],
        'rm': [...Array(13).keys()],
    });

    function initMapSetting(systemInfo)
    {
        if( !systemInfo )
        {
            systemInfo = {
                "systemName": '',
                "hostUrl": "",
                "map": {
                    "latitude": 36.3372,
                    "longitude": 127.3227,
                    "zoom": 16,
                    "style": 'Streets',
                    "locationOffset": 0,
                    "markerSize": 1,
                    "edgeZoom": 5,
                    "country": "us",
                    "mapboxToken": ""
                },
                "serverStatusAlert": {
                    "diskUsagePercent": 0
                },
                "alert": {
                    "repeatIntervalHour": 1,
                    "defaultEndpoint": "Not Used"
                },
                "bugReport": false
            };
        }
        
        showEdgeRef.current.level = parseFloat(systemInfo.map.edgeZoom);
        showEdgeRef.current.markerSize = parseInt(systemInfo.map.markerSize);

        let temp = {lat: parseFloat(systemInfo.map.latitude), lng: parseFloat(systemInfo.map.longitude), zoom: parseFloat(systemInfo.map.zoom)};
        mapInfoRef.current = {lat: temp.lat, lng: temp.lng, zoom: temp.zoom.toFixed(2)};
        mapDefaultRef.current = {lat: temp.lat, lng: temp.lng, zoom: temp.zoom.toFixed(2), locationOffset: systemInfo.map.locationOffset};
        setMapConfig(mapInfoRef.current);

        maruMap.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: getMapStyle(systemInfo.map.style),
            center: [temp.lng, temp.lat],
            zoom: temp.zoom,
        });
        maruMap.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    }

    function getMapInfo()
    {
        let removeResource = [...resourceList.current];
        Promise.all( [getApiSitesSummary(), getApiSitesAlertStatus()] )
        .then( data => {

            const result = {summary: data[0], sitesSeverity: data[1]};
            
            if (!Array.isArray(result.summary)) return;
            for( const siteInfo of result.summary )
            {
                removeResource = removeResource.filter( (source) => {return source.siteName !== siteInfo.name} );

                //site ID 확인
                const siteExist = siteList.current.indexOf(siteInfo.name);
                if( siteExist === -1 )
                {
                    siteList.current.push(siteInfo.name);

                    //create marker
                    const siteLocArr = [siteInfo.longitude, siteInfo.latitude];
                    const siteMarker = new Marker({
                        element:makeMarkerDefaultSite(siteInfo, 'site', `bg-${siteInfo.severity}`, false),
                        anchor:'bottom',
                    })
                    .setLngLat(siteLocArr)
                    .addTo(maruMap.current);
                    
                    resourceList.current.push({siteName: siteInfo.name, resource: siteMarker});

                    //other markers
                    let severityArr = {'m-agent': [], 's-agent': [], 'r-agent': [], 'rm': []};
                    for( const edge of siteInfo.edgeList )
                    {
                        const locArr = [edge.longitude, edge.latitude];
                        const locTxt = `${edge.longitude}_${edge.latitude}`;
                        const markerId = makeSiteMarkerId(siteInfo.name, locTxt);
                        const existMarker = document.getElementById(markerId) !== null;
                        let isOther = true;
                        if( Math.abs( Math.abs(siteLocArr[0]) - Math.abs(locArr[0]) ) <= mapDefaultRef.current.locationOffset
                        && Math.abs( Math.abs(siteLocArr[1]) - Math.abs(locArr[1]) ) <= mapDefaultRef.current.locationOffset )
                        {
                            isOther = false;
                        }

                        if( !existMarker && isOther )
                        {
                            const otherMarker = new Marker({
                                element:makeMarkerDefaultSite(siteInfo, locTxt, `bg-${siteInfo.severity}`, true),
                                anchor:'bottom',
                            })
                            .setLngLat(locArr)
                            .addTo(maruMap.current);

                            setLineData(siteInfo.name, 'site', locTxt, siteLocArr, locArr);
                            
                            resourceList.current.push({siteName: siteInfo.name, resource: otherMarker});
                        }

                        let severityPre = '';
                        let severityCur = `bg-${edge.severity}`;

                        if( !severityArr.hasOwnProperty(edge.type) )
                        {
                            severityArr[edge.type] = [];
                        }
                        
                        if( severityArr[edge.type].length > 0 )
                        {
                            severityPre = severityArr[edge.type].at(-1);
                            severityArr[edge.type].push(severityCur);
                            severityCur = getHighSeveriry(severityArr[edge.type]);
                        }
                        else
                        {
                            severityArr[edge.type].push(severityCur);
                        }
                        
                        if( isOther )
                        {
                            makeMarkerAdditionalEdge(siteInfo, edge, `${edge.longitude}_${edge.latitude}`, severityPre, severityCur);
                        }
                        else
                        {
                            makeMarkerAdditionalEdge(siteInfo, edge, 'site', severityPre, severityCur);
                        }
                    }
                }
            }

            return result;
        }).then( result => {
            if (!result) return;
            for( const remove of removeResource )
            {
                //remove marker
                remove.resource.remove();
                resourceList.current = resourceList.current.filter( (marker) => {return marker.siteName !== remove.siteName} );
                
                const siteIdx = siteList.current.indexOf(remove.siteName);
                if( siteIdx !== -1 )
                {
                    siteList.current.splice(siteIdx);
                }
            }

            return result;
        }).then( result => {
            if (!result) return;
            //초기 설정이 완료되기 전에 필터설정을 클릭했을때 useEffect에서 처리하지 않고 있다가 marker 작업이 완료된 후 처리하도록.
            let type = '';
            if( searchTypeCur !== 'none' )
            {
                type = searchTypeCur;
            }

            if( filterSeverityCur !== 'none' )
            {
                markerFilterSearch(type);
            }

            if (!Array.isArray(result.sitesSeverity)) return;
            const severityArray = result.sitesSeverity.sort((a, b) => strArraySortAsc(a.site.toLowerCase(), b.site.toLowerCase()));
            const summaryArray = result.summary.sort((a, b) => strArraySortAsc(a.name.toLowerCase(), b.name.toLowerCase()));
            
            if( JSON.stringify(severityArray) !== JSON.stringify(sitesAlertStatus) )
            {
                setSitesAlertStatus(severityArray);
            }
            
            if( JSON.stringify(summaryArray) !== JSON.stringify(sitesSummary) )
            {
                setSitesSummary(severityArray);
                if( atferInit.current )
                {
                    updateMarkerStatus(summaryArray);
                }
            }

            if( !atferInit.current )
            {
                atferInit.current = true;
                parseZoom();
            }
        });
    }

    function updateMarkerStatus(summary)
    {
        for(let data of summary)
        {
            const siteColor = `bg-${data.severity}`;

            const siteIcon = document.getElementById(makeSiteIconId(data.name, 'site'));
            const siteMarker = document.getElementById(makeSiteMarkerId(data.name, 'site'));
            
            const aeaIcon = document.getElementById(makeAeaIconId(data.name, 'site'));
            const aeaCount = document.getElementById(makeAeaCountId(data.name, 'site'));
            const aeaMarker = document.getElementById(makeAeaMarkerId(data.name, 'site'));

            if(siteMarker)
            {
                if(aeaCount)
                {
                    aeaCount.textContent = data.aeaCount;
                }

                if(aeaMarker)
                {
                    if( data.aeaWakeUp || data.aeaCount > 0 )
                    {
                        if( aeaMarker.classList.contains('d-none') )
                        {
                            aeaMarker.classList.remove('d-none');
                        }
                    }
                    else
                    {
                        if( !aeaMarker.classList.contains('d-none') )
                        {
                            aeaMarker.classList.add('d-none');
                        }
                    }

                    if( data.aeaWakeUp )
                    {
                        if( aeaIcon.src !== '/exclamation-triangle-warn-fill.svg' )
                        {
                            aeaIcon.src = '/exclamation-triangle-warn-fill.svg';
                        }
                    }
                    else
                    {
                        if( aeaIcon.src !== '/exclamation-triangle-normal.svg' )
                        {
                            aeaIcon.src = '/exclamation-triangle-normal.svg';
                        }
                    }
                }

                const preSiteAlert = siteIcon.getAttribute('severity');
                if( preSiteAlert !== siteColor)
                {
                    const isvisible = Array.from( siteMarker.classList ).indexOf('d-none');

                    siteIcon.classList.remove(preSiteAlert);
                    siteIcon.classList.add(siteColor);
                    siteIcon.setAttribute('severity', siteColor);

                    if( selectSeverity.current !== '' )
                    {
                        if( selectSeverity.current === data.severity )
                        {
                            //show
                            if( isvisible !== -1)
                            {
                                siteMarker.classList.remove('d-none');
                                if( showEdgeRef.current.flag )
                                {
                                    showEdgeMarker(true);
                                }
                            }
                        }
                        else
                        {
                            //hide
                            if( isvisible === -1 )
                            {
                                siteMarker.classList.add('d-none');
                                if( showEdgeRef.current.flag )
                                {
                                    showEdgeMarker(false);
                                }
                            }
                        }
                    }
                }

                let once = true;
                let severityArr = {'m-agent': [], 's-agent': [], 'r-agent': [], 'rm': []};
                for( const edge of data.edgeList )
                {
                    const siteLocArr = [data.longitude, data.latitude];
                    const locArr = [edge.longitude, edge.latitude];
                    let isOther = true;
                    let edgeLoc = 'site';
                    
                    if( Math.abs( Math.abs(siteLocArr[0]) - Math.abs(locArr[0]) ) <= mapDefaultRef.current.locationOffset
                    && Math.abs( Math.abs(siteLocArr[1]) - Math.abs(locArr[1]) ) <= mapDefaultRef.current.locationOffset )
                    {
                        isOther = false;
                    }
                    
                    if( isOther )
                    {
                        edgeLoc = `${edge.longitude}_${edge.latitude}`;

                        if( once )
                        {
                            const locTxt = `${edge.longitude}_${edge.latitude}`;
                            const otherSiteId = makeSiteIconId(data.name, locTxt);
                            const otherSiteElemt = document.getElementById(otherSiteId);

                            if( otherSiteElemt )
                            {
                                otherSiteElemt.classList.remove(preSiteAlert);
                                otherSiteElemt.classList.add(siteColor);
                                otherSiteElemt.setAttribute('severity', siteColor);
        
                                once = false;
                            }
                        }
                    }

                    const iconId = makeEdgeIconId(data.name, edge.type, edgeLoc);
                    const iconElemt = document.getElementById(iconId);
                    
                    let severityPre = iconElemt.getAttribute('severity');
                    let severityCur = `bg-${edge.severity}`;
                    if( severityArr[edge.type].length > 0 )
                    {
                        severityPre = severityArr[edge.type].at(-1);
                        severityArr[edge.type].push(severityCur);
                        severityCur = getHighSeveriry(severityArr[edge.type]);
                    }
                    else
                    {
                        severityArr[edge.type].push(severityCur);
                    }
                    
                    if( iconElemt )
                    {
                        if( !severityPre || severityPre.length === 0 )
                        {
                            iconElemt.classList.add(severityCur);
                        }
                        else
                        {
                            iconElemt.classList.replace(severityPre, severityCur);
                        }
                        
                        iconElemt.setAttribute('severity', severityCur);
                    }
                }
            }
        }
    }

    // function updateMarkerStatus(severityData)
    // {
    //     for(let data of severityData)
    //     {
    //         const siteColor = `bg-${data.severity}`;
    //         const siteIcon = document.getElementById(setSiteIconId(data.site, 'site'));
    //         const siteMarker = document.getElementById(setSiteMarkerId(data.site, 'site'));

    //         if(siteMarker)
    //         {
    //             const preSiteAlert = siteIcon.getAttribute('severity');
    //             if( preSiteAlert !== siteColor)
    //             {
    //                 siteIcon.classList.remove(preSiteAlert);
    //                 siteIcon.classList.add(siteColor);

    //                 const isvisible = Array.from( siteMarker.classList ).indexOf('d-none');
                    
    //                 siteIcon.setAttribute('severity', siteColor);

    //                 if( selectSeverity.current !== '' )
    //                 {
    //                     if( selectSeverity.current === data.severity )
    //                     {
    //                         //show
    //                         if( isvisible !== -1)
    //                         {
    //                             siteMarker.classList.remove('d-none');
    //                             if( showEdgeRef.current.flag )
    //                             {
    //                                 showEdgeMarker(true);
    //                             }
    //                         }
    //                     }
    //                     else
    //                     {
    //                         //hide
    //                         if( isvisible === -1 )
    //                         {
    //                             siteMarker.classList.add('d-none');
    //                             if( showEdgeRef.current.flag )
    //                             {
    //                                 showEdgeMarker(false);
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }

    function makeAeaMarkerId(siteName, location)
    {
        return `aeaMarker_${siteName}_${location}`;
    }

    function makeAeaIconId(siteName, location)
    {
        return `aeaIcon_${siteName}_${location}`;
    }

    function makeAeaCountId(siteName, location)
    {
        return `aeaCount_${siteName}_${location}`;
    }

    function makeSiteMarkerId(siteName, location)
    {
        return `siteMarker_${siteName}_${location}`;
    }

    function makeSiteIconId(siteName, location)
    {
        return `siteIcon_${siteName}_${location}`;
    }

    function makeEdgeFrameId(siteName, location)
    {
        return `edgeMarker_${siteName}_${location}`;
    }

    function makeEdgeIconId(siteName, edgeType, location)
    {
        return `edgeIcon_${siteName}_${edgeType}_${location}`;
    }

    function makeEdgeBadgeId(siteName, edgeType, location)
    {
        return `edgeBadge_${siteName}_${edgeType}_${location}`;
    }

    function makeMarkerDefaultSite(siteInfo, location, color, isOther) {
    
        const siteName = siteInfo.name;

        const translateFrame = document.createElement('div');
        const aeaFrame = document.createElement('div');
        const aeaIcon = document.createElement('img');
        const aeaStatusTxt = document.createElement('span');
        const aeaStatusCnt = document.createElement('span');
        const markerFrame = document.createElement('div');
        const edgeFrame = document.createElement('div');
        const edgeMarker1 = document.createElement('div');
        const edgeMarker2 = document.createElement('div');
        const edgeMarker3 = document.createElement('div');
        const edgeMarker4 = document.createElement('div');
        const edgeBadge1 = document.createElement('span');
        const edgeBadge2 = document.createElement('span');
        const edgeBadge3 = document.createElement('span');
        const edgeBadge4 = document.createElement('span');
        const siteFrame = document.createElement('div');
        const siteMarker = document.createElement('div');

        translateFrame.className = "d-flex flex-column map-icons translate";
        edgeFrame.className = "d-flex map-edge-area";

        if(isOther)
        {
            translateFrame.classList.add("d-none");
        }
        else
        {
            edgeFrame.classList.add("d-none");
        }

        markerFrame.className = `map-icons`;
        
        aeaFrame.className = `map-icons map-site-area aea-frame`;
        aeaFrame.style.cursor='pointer';
        aeaFrame.addEventListener('click', () => {showAeaModal(siteInfo)});
        aeaFrame.id = makeAeaMarkerId(siteName, location);

        aeaIcon.className = 'text-error';
        if( siteInfo.aeaWakeUp )
        {
            aeaIcon.src = '/exclamation-triangle-warn-fill.svg';
        }
        else
        {
            aeaIcon.src = '/exclamation-triangle-normal.svg';
        }
        
        aeaIcon.id = makeAeaIconId(siteName, location);

        aeaStatusTxt.className = 'text-white';
        aeaStatusTxt.textContent = ` AEA `;

        aeaStatusCnt.className = 'text-white';
        aeaStatusCnt.textContent = siteInfo.aeaCount;
        aeaStatusCnt.id = makeAeaCountId(siteName, location);

        if( !siteInfo.aeaWakeUp && siteInfo.aeaCount === 0 )
        {
            aeaFrame.classList.add('d-none');
        }

        aeaFrame.appendChild(aeaIcon);
        aeaFrame.appendChild(aeaStatusTxt);
        aeaFrame.appendChild(aeaStatusCnt);

        translateFrame.id = makeSiteMarkerId(siteName, location);

        const markerSize = ['sm', 'md', 'lg'];
        translateFrame.classList.add(markerSize[showEdgeRef.current.markerSize]);
        markerFrame.classList.add(markerSize[showEdgeRef.current.markerSize]);
        aeaFrame.classList.add(markerSize[showEdgeRef.current.markerSize]);

        edgeFrame.id = makeEdgeFrameId(siteName, location);
        
        edgeMarker1.id = makeEdgeIconId(siteName, 'm-agent', location);
        edgeMarker2.id = makeEdgeIconId(siteName, 's-agent', location);
        edgeMarker3.id = makeEdgeIconId(siteName, 'r-agent', location);
        edgeMarker4.id = makeEdgeIconId(siteName, 'rm', location);

        edgeMarker1.className = 'edge-box disable-edge';
        edgeMarker2.className = 'edge-box disable-edge';
        edgeMarker3.className = 'edge-box disable-edge';
        edgeMarker4.className = 'edge-box disable-edge';

        edgeMarker1.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeMarker2.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeMarker3.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeMarker4.classList.add(markerSize[showEdgeRef.current.markerSize]);

        edgeMarker1.textContent = 'M';
        edgeMarker2.textContent = 'S';
        edgeMarker3.textContent = 'R';
        edgeMarker4.textContent = 'T';

        edgeBadge1.id = makeEdgeBadgeId(siteName, 'm-agent', location);
        edgeBadge2.id = makeEdgeBadgeId(siteName, 's-agent', location);
        edgeBadge3.id = makeEdgeBadgeId(siteName, 'r-agent', location);
        edgeBadge4.id = makeEdgeBadgeId(siteName, 'rm', location);

        edgeBadge1.className = 'badge d-none';
        edgeBadge2.className = 'badge d-none';
        edgeBadge3.className = 'badge d-none';
        edgeBadge4.className = 'badge d-none';
        
        edgeBadge1.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeBadge2.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeBadge3.classList.add(markerSize[showEdgeRef.current.markerSize]);
        edgeBadge4.classList.add(markerSize[showEdgeRef.current.markerSize]);

        edgeBadge1.textContent = '0';
        edgeBadge2.textContent = '0';
        edgeBadge3.textContent = '0';
        edgeBadge4.textContent = '0';

        siteFrame.className = `d-flex map-site-area`;
        
        siteMarker.className = `${color} edge-box`;
        siteMarker.classList.add(markerSize[showEdgeRef.current.markerSize]);
        siteMarker.setAttribute('severity', color);
        siteMarker.textContent = siteName;
        siteMarker.style.cursor='pointer';
        siteMarker.addEventListener('click', () => {showDetailSiteCanvas(siteInfo)});
        siteMarker.id = makeSiteIconId(siteName, location);
        siteMarker.setAttribute('is_site', true);

        edgeMarker1.appendChild(edgeBadge1);
        edgeMarker2.appendChild(edgeBadge2);
        edgeMarker3.appendChild(edgeBadge3);
        edgeMarker4.appendChild(edgeBadge4);

        siteFrame.appendChild(siteMarker);

        edgeFrame.appendChild(edgeMarker1);
        edgeFrame.appendChild(edgeMarker2);
        edgeFrame.appendChild(edgeMarker3);
        edgeFrame.appendChild(edgeMarker4);
        markerFrame.appendChild(edgeFrame);
        markerFrame.appendChild(siteFrame);
        
        translateFrame.appendChild(aeaFrame);
        translateFrame.appendChild(markerFrame);

        return translateFrame;
    }

    function makeMarkerAdditionalEdge(siteInfo, edgeInfo, location, severityPre, severityCur) {
        
        const siteName = siteInfo.name;

        const iconId =  makeEdgeIconId(siteName, edgeInfo.type, location);
        const badgeId = makeEdgeBadgeId(siteName, edgeInfo.type, location);

        const iconElemt = document.getElementById(iconId);
        const badgeElemt = document.getElementById(badgeId);

        if( iconElemt )
        {
            if( Array.from(iconElemt.classList).indexOf('disable-edge') !== -1 )
            {
                iconElemt.classList.add('pointer');
                // iconElemt.classList.add(`bg-${edgeInfo.severity}`);
                iconElemt.classList.remove('disable-edge');
                iconElemt.setAttribute('edgeType', edgeInfo.type);
                iconElemt.setAttribute('edgeLocTxt', location);
                // iconElemt.setAttribute('severity', [`bg-${edgeInfo.severity}`]);
                iconElemt.addEventListener('click', (e) => {showSelectEdgeModal(e, siteInfo)});

                badgeElemt.textContent = '1';
            }
            else
            {
                // const severity = iconElemt.getAttribute('severity').split(',');
                // severity.push(`bg-${edgeInfo.severity}`);
                // iconElemt.setAttribute('severity', severity);

                // const highSeveriry = getHighSeveriry(severity);
                
                // for (let idx = 0; idx < iconElemt.classList.length; idx++) {
                //     if (iconElemt.classList[idx].includes('bg-')) {
                //         iconElemt.classList.replace(iconElemt.classList[idx], highSeveriry);
                //         break;
                //     }
                // }

                if( badgeElemt.textContent === '1' )
                {
                    badgeElemt.classList.add('bg-danger');
                    badgeElemt.classList.remove('d-none');
                }

                badgeElemt.textContent = String(parseInt(badgeElemt.textContent) + 1);
            }

            if( severityPre.length === 0 )
            {
                iconElemt.classList.add(severityCur);
            }
            else
            {
                iconElemt.classList.replace(severityPre, severityCur);
            }
            
            iconElemt.setAttribute('severity', severityCur);
        }
    }
    
    const setLineData = (name, loc1, loc2, coordinate1, coordinate2) => {
        const lineDataId = `line_data_${name}_${loc1}_${loc2}`;

        const lineData = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: [
                    coordinate1,
                    coordinate2
                ]
            },
            properties: {}
        };
        
        const source = maruMap.current.addSource(lineDataId, {
            type: 'geojson',
            data: lineData
        });

        resourceList.current.push({siteName: name, resource: source});
    }

    function setLineLayer(name, layerId, dataId)
    {        
        const layer = maruMap.current.addLayer({
            id: layerId,
            type: 'line',
            source: dataId,
            paint: {
                'line-width': 1,
                'line-color': '#4466ff'
            }
        });

        resourceList.current.push({siteName: name, resource: layer});
    }

    function showEdgeMarker(isShow)
    {
        setLoading(true);

        Promise.resolve( getApiSitesSummary() )
        .then( sitesArr => {
            if (!Array.isArray(sitesArr)) return;
            const summaryArray = sitesArr.sort((a, b) => strArraySortAsc(a.name.toLowerCase(), b.name.toLowerCase()));

            for( const siteInfo of summaryArray )
            {
                const sitemarker = document.getElementById(makeSiteMarkerId(siteInfo.name, 'site'));
                if( isShow && Array.from(sitemarker.classList).indexOf('d-none') !== -1 )
                {
                    for( const edge of siteInfo.edgeList )
                    {
                        const locTxt = `${edge.longitude}_${edge.latitude}`;
                        const lineLayerId = `line_layer_${siteInfo.name}_site_${locTxt}`;
                        
                        if( maruMap.current.getLayer(lineLayerId) )
                        {
                            maruMap.current.removeLayer(lineLayerId);
                        }
                    }

                    continue;
                }
                
                const siteLocArr = [siteInfo.longitude, siteInfo.latitude];
                const siteEdgeFrame = document.getElementById(makeEdgeFrameId(siteInfo.name, 'site'));

                if( isShow )
                {
                    siteEdgeFrame.classList.remove('d-none');
                }
                else
                {
                    siteEdgeFrame.classList.add('d-none');
                }

                for( const edge of siteInfo.edgeList )
                {
                    const locArr = [edge.longitude, edge.latitude];
                    const locTxt = `${edge.longitude}_${edge.latitude}`;
                    const markerId = makeSiteMarkerId(siteInfo.name, locTxt);
                    const otherMarker = document.getElementById(markerId);

                    const lineDataId = `line_data_${siteInfo.name}_site_${locTxt}`;
                    const lineLayerId = `line_layer_${siteInfo.name}_site_${locTxt}`;

                    if( otherMarker !== null && JSON.stringify(siteLocArr) !== JSON.stringify(locArr))
                    {
                        if( isShow )
                        {
                            otherMarker.classList.remove('d-none');

                            if( maruMap.current.getSource(lineDataId) && !maruMap.current.getLayer(lineLayerId) )
                            {
                                setLineLayer(siteInfo.name, lineLayerId, lineDataId);
                            }
                        }
                        else
                        {
                            otherMarker.classList.add('d-none');
                            
                            if( maruMap.current.getLayer(lineLayerId) )
                            {
                                maruMap.current.removeLayer(lineLayerId);
                            }
                        }
                    }
                }
            }

            return true;
        })
        .then( done => {
            setLoading(false);
        })
        .catch( e => {
            setLoading(false);
        });
    }

    function moveDefault()
    {
        maruMap.current.jumpTo({center: [mapDefaultRef.current.lng, mapDefaultRef.current.lat], zoom: mapDefaultRef.current.zoom});
    }

    function moveLocation(coordinates)
    {
        maruMap.current.flyTo({center: coordinates, zoom: 6.0});
    }

    const selectSiteSeverity = (status) =>
    {
        setFilterSeverityCur(status);
    }
    
    const markerFilterSearch = (type) => {
        if( filterSeverityCur === filterSeverityPre && searchTypeCur === searchTypePre && searchNameCur === searchNamePre )
        {
            return;
        }
        
        setFilterSeverityPre(filterSeverityCur);
        setSearchNamePre(searchNameCur);
        setSearchTypePre(searchTypeCur);
        setLoading(true);

        maruMap.current.jumpTo({center: [mapDefaultRef.current.lng, mapDefaultRef.current.lat], zoom: mapDefaultRef.current.zoom});
        
        const queryArr = Array.from(document.querySelectorAll(".translate"));

        for( const query of queryArr )
        {
            if( query.className.indexOf('d-none') === -1 )
            {
                query.classList.add('d-none');
            }
        }
        
        if( type === '' )
        {
            if( filterSeverityCur!=='none' )
            {
                selectSeverity.current = filterSeverityCur;
            }

            const severity = `${filterSeverityCur==='none'?'':filterSeverityCur}`;

            Promise.resolve( getApiSitesCount('', severity) )
            .then( count => {
                Promise.resolve( getApiSites(count.count, 1, '', severity, '', '') )
                .then( dataArr => {
                    for( const data of dataArr )
                    {
                        const siteMarker = document.getElementById(makeSiteMarkerId(data.site, 'site'));
                        if( siteMarker )
                        {
                            siteMarker.classList.remove('d-none');
                        }
                    }
                    
                    return true;
                })
                .then( done => {
                    setLoading(false);
                    parseZoom();
                })
                .catch( e => {
                    setLoading(false);
                });
            })
            .catch( e => {
                setLoading(false);
            });
        }
        else if( type === 'callsign' )
        {
            if( filterSeverityCur === '' || filterSeverityCur === 'none' )
            {
                const siteMarker = document.getElementById(makeSiteMarkerId(searchNameCur, 'site'));
                if( siteMarker )
                {
                    siteMarker.classList.remove('d-none');
                    setLoading(false);
                }
            }
            else
            {
                Promise.resolve( getApiSitesSite(searchNameCur) )
                .then( siteInfo => {
                    if( siteInfo.severity === filterSeverityCur )
                    {
                        const siteMarker = document.getElementById(makeSiteMarkerId(searchNameCur, 'site'));
                        if( siteMarker )
                        {
                            siteMarker.classList.remove('d-none');
                        }
                    }
                    
                    return true;
                })
                .then( done => {
                    setLoading(false);
                    parseZoom();
                })
                .catch( e => {
                    setLoading(false);
                });
            }
        }
        else if( type === 'market' )
        {
            const severity = `${filterSeverityCur==='none'?'':filterSeverityCur}`;
            const searchName = `${searchNameCur===undefined?'':searchNameCur}`;
            
            Promise.resolve( getApiSitesCount(searchName, severity) )
            .then( count => {
                Promise.resolve( getApiSites(count.count, 1, searchName, severity, '', '') )
                .then( dataArr => {
                    for( const data of dataArr )
                    {
                        const siteMarker = document.getElementById(makeSiteMarkerId(data.site, 'site'));
                        if( siteMarker )
                        {
                            siteMarker.classList.remove('d-none');
                        }
                    }

                    return true;
                })
                .then( done => {
                    setLoading(false);
                    parseZoom();
                })
                .catch( e => {
                    setLoading(false);
                });
            })
            .catch( e => {
                setLoading(false);
            });
        }
    }

    function parseZoom(moveZoom = false)
    {
        let tempZoom = maruMap.current.getZoom().toFixed(2);
        
        if( moveZoom )
        {
            if( showEdgeRef.current.flag && tempZoom < showEdgeRef.current.level )
            {
                showEdgeRef.current.flag = false;
                showEdgeMarker(false);
            }
            else if( !showEdgeRef.current.flag && tempZoom >= showEdgeRef.current.level )
            {
                showEdgeRef.current.flag = true;
                showEdgeMarker(true);
            }
        }
        else
        {
            if( tempZoom < showEdgeRef.current.level  )
            {
                showEdgeRef.current.flag = false;
                showEdgeMarker(false);
            }
            else if( tempZoom >= showEdgeRef.current.level )
            {
                showEdgeRef.current.flag = true;
                showEdgeMarker(true);
            }
        }

        mapInfoRef.current = {...mapInfoRef.current, lng:maruMap.current.getCenter().lng, lat:maruMap.current.getCenter().lat, zoom:tempZoom};
        setMapConfig(mapInfoRef.current);
    }

    useEffect(() => {
        if( mapTokenStatus.current !== 0 ) return;
        // console.log('useEffect - checkToken');

        if( sessionStorage.getItem('siteWidgetInfo') == null )
        {
            sessionStorage.setItem('siteWidgetInfo', JSON.stringify(siteWidgerConfig.current));
        }

        if( sessionStorage.getItem('edgeWidgetInfo') == null )
        {
            sessionStorage.setItem('edgeWidgetInfo', JSON.stringify(edgeWidgerConfig.current));
        }

        // if (!maruMap.current) // initialize map only once
        {
            Promise.resolve( getApiConfigSystem() )
            .then( systemInfo => {
                
                if( !systemInfo.map.mapboxToken )
                {
                    showToast('Invalid Map Token', 'error');
                    mapTokenStatus.current = 2;
                    return;
                }

                Promise.resolve( getApiMapboxTokenCheck(systemInfo.map.mapboxToken) )
                .then( data => {
                    if( data && data.code )
                    {
                        if( data.code === 'TokenValid')
                        {
                            // TokenValid	토큰이 유효하고 활성 상태입니다.
                            // TokenMalformed	토큰을 구문 분석할 수 없습니다.
                            // TokenInvalid	토큰 서명이 검증되지 않습니다.
                            // TokenExpired	토큰은 일시적이며 만료되었습니다.
                            // TokenRevoked	토큰의 승인이 삭제되었습니다.
                            setSystemInfo(systemInfo);
                            mapTokenStatus.current = 1;
                        }
                        else
                        {
                            showToast(data.code, 'error');
                            mapTokenStatus.current = 2;
                        }
                    }
                    else
                    {
                        showToast('Map Token Validation Failed', 'error');
                        mapTokenStatus.current = 2;
                    }
                })
                .catch( e => {
                    showToast('Map Token Validation Failed', 'error');
                    mapTokenStatus.current = 2;
                });
            });
        }
    });

    useEffect( () => {
        if( systemInfo && mapTokenStatus.current === 1 )
        {
            // console.log('useEffect - initMapSetting');
            mapboxgl.accessToken = systemInfo.map.mapboxToken;
            initMapSetting(systemInfo);
        }
    }, [systemInfo, mapTokenStatus.current] );
    
    useEffect(() => {
        if (!maruMap.current) return; // wait for map to initialize
        if (isStyleLoaded.current) return; // wait for map to load
        
        maruMap.current.on('load', () => {
            // console.log('useEffect - loaded');
            isStyleLoaded.current = true;
            getMapInfo();
        });
    }, [maruMap.current]);

    useEffect( () => {
        if( siteList.current.length > 0 && filterSeverityCur !== 'none' )
        {
            // console.log('useEffect - filter:severity');
            if( searchTypeCur === 'none' )
            {
                markerFilterSearch('');
            }
            else
            {
                markerFilterSearch(searchTypeCur);
            }
        }

    }, [filterSeverityCur]);

    useEffect( () => {
        if( siteList.current.length < 1 || searchTypeCur !== '' )
        {
            return;
        }

        // console.log('useEffect - filter:type');
        markerFilterSearch(searchTypeCur);

    }, [searchTypeCur]);

    useEffect( () => {
        if( siteList.current.length < 1 || !searchNameCur || searchNameCur.length < 1 )
        {
            return;
        }

        // console.log('useEffect - filter:name');
        markerFilterSearch(searchTypeCur);

    }, [searchNameCur]);
    
    useEffect(() => {
        if (!isStyleLoaded.current) return; // wait for map to load
        
        maruMap.current.on('move', () => {
            // console.log('useEffect - move');
            parseZoom(true);
        });
    });

    useEffect( () => {
        if (!isStyleLoaded.current) return; // wait for map to load
        if( sitesAlertStatus )
        {
            // console.log('useEffect - update');
            let refresh = false;
            if( sitesAlertStatus.length !== siteList.current.length )
            {
                refresh = true;
            }

            let findArr = [...siteList.current];
            for( const data of sitesAlertStatus )
            {
                const filter = siteList.current.filter( (item) => {return item === data.site});
                if( filter.length < 1 )
                {
                    refresh = true;
                    break;
                }

                findArr = findArr.filter( (item) => {return item.siteName !== data.site});
            }
            
            if( refresh || findArr.length > 0 )
            {
                getMapInfo();
            }
        }

    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, 10000 );

    function runUpdate()
    {
        setUpdate(!update);
    }

    // 상단 status bar와 싱크를 맞추기 위해 edge marker의 갱신없이 site marker만 갱신했던 부분.
    // 다시 edge marker도 status에 맞게 상태를 추가해야 됨에 따라 수정됨. 240312_colin
    // useInterval(() =>
    // {
    //     if (!maruMap.current && !invalidMapToken.current) return; // wait for map to initialize
        
    //     Promise.resolve( getApiSitesAlertStatus() )
    //     .then( severityData => {
            
    //         const array = severityData.sort((a, b) => strArraySortAsc(a.site.toLowerCase(), b.site.toLowerCase()));
            
    //         if( JSON.stringify(array) !== JSON.stringify(sitesAlertStatusArr) )
    //         {
    //             setSitesAlertStatusArr(array);
    //             updateMarkerStatus(array);
    //         }
    //     });

    // }, 2000);
    
    return (
        <>
            <Title title='DashBoard'></Title>
            <div className="d-flex flex-column mt-2 position-relative">
                <div className="d-flex flex-wrap top-status-area">
                    <TopSitesAlertStatusSection searchName={searchNameCur} setSearchName={setSearchNameCur} searchType={searchTypeCur} setSearchType={setSearchTypeCur} sitesSeveriry={sitesAlertStatus} selectSiteSeverity={selectSiteSeverity} active={isStyleLoaded.current}/>
                </div>
                <div className="d-flex">
                    <div className="section col main-map" ref={mapContainer} >
                        <div className={`pointer location-bar ${showEdgeRef.current.flag?'bg-label-success':''}`} onClick={moveDefault}>
                            Lng: {mapInfoRef.current.lng} | Lat: {mapInfoRef.current.lat} | Zoom: {mapInfoRef.current.zoom}
                        </div>
                    </div>
                </div>
            </div>
            {detailSiteCanvas&&<SiteOffCanvas siteUpdate={update} siteName={detailSiteInfo.name} show={detailSiteCanvas} result={showDetailEdgeCanvas} moveLocation={moveLocation} handleClose={cloaseDetailSiteCanvas}></SiteOffCanvas>}
            {detailEdgeCanvas&&<EdgeOffCanvas siteUpdate={update} siteInfo={detailSiteInfo} id={detailEdgeInfo.id} result={showDetailSiteCanvas} moveLocation={moveLocation} show={detailEdgeCanvas} handleClose={cloaseDetailEdgeCanvas}></EdgeOffCanvas>}
            {selectEdgeModal&&<SelectEdgeModal edgeInfo={detailEdgeList} result={showDetailEdgeCanvas} show={selectEdgeModal} handleClose={cloaseSelectEdgeModal}></SelectEdgeModal>}
            {aeaModal&&<AeaModal siteInfo={detailSiteInfo} show={aeaModal} handleClose={cloaseAeaModal}></AeaModal>}
            <LoadingSpinner loading={loading}/>
        </>
    )
}

export default PageDashBoard;